import AdminEmailSmtpSettingsPage from '../../../components/admin/settings/AdminEmailSmtpSettingsPage'

export default function SettingsEmail() {
  return <AdminEmailSmtpSettingsPage />
}
